import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useGet, usePost } from "seed/api";
import l from "components/util/l";
import View from "components/tmisc/chat/history/History.view";

const PAGE_SIZE = 10;

const History = ({
  currentChatId,
  flow,
  nodeId, // The process the slot runs, pointed at by id
  processName, // The same process named instead of pointed at, which is how an inherited one is reached
  onClose,
  onSelectChat,
}) => {

  const [pageNum, setPageNum] = useState(1);
  const [resumingChatId, setResumingChatId] = useState(null);

  // A slot that runs a process only lists the conversations that process ran in: what
  // the user is looking for is one of its own runs, not every chat of the flow.
  const reqChats = useGet("/chats/get_history", {
    flow_id: flow.id,
    page_num: pageNum,
    page_size: PAGE_SIZE,
    process_name: processName,
    node_id: nodeId,
  });

  // The chat is opened on the answer, not on the click: the resumed run writes into the
  // thread, and landing there before it is armed shows the conversation as it was left.
  const [callResumeChat] = usePost("/chats/resume_chat_execution", {
    onCompleted: (data) => onSelectChat(data.chatId),
    onError: () => {
      setResumingChatId(null);
      toast(l("No se pudo reanudar la conversación%CH037"), { type: "error" });
    },
  });

  useEffect(() => {
    reqChats.refetch();
  }, [pageNum]); // eslint-disable-line react-hooks/exhaustive-deps

  const onClickResumeChat = (chatId) => {
    setResumingChatId(chatId);
    callResumeChat({ chat_id: chatId });
  };

  const { chats = [], totalPages = 0 } = reqChats.data ?? {};

  return <View
    chats={chats}
    currentChatId={currentChatId}
    isLoading={reqChats.loading}
    pageNum={pageNum}
    processName={processName}
    resumingChatId={resumingChatId}
    totalPages={totalPages}
    setPageNum={setPageNum}
    onClickChat={onSelectChat}
    onClickResumeChat={onClickResumeChat}
    onClose={onClose}
  />;

};

export default History;
